import styled from '@emotion/styled';
import breakpoints from '../../Theme/breakpoints';

const Border = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.blackHigh};
  margin: 24px -16px;

  @media (min-width: ${breakpoints.sm}px) {
    flex-basis: calc(100% + 32px);
  }

  @media (min-width: ${breakpoints.lg}px) {
   display: none;
  }
`;

export default Border;
